import { connect, ConnectedProps } from 'react-redux';
import CreateStepModal from './create-step-modal';
import {
  SequenceStepAction,
  SequenceStepExecutionType,
  SequenceStepType,
  StepType,
} from '../../../enums';
import {
  addSequenceStepRequest,
  addSequenceStepVariantRequest,
  getSequenceRequest,
  getSubsequenceRequest,
  getTaskAssigneeListRequest,
  updateSequenceStepVariantDataRequest,
  uploadAttachmentRequest,
  deleteAttachmentRequest,
  imageUploadRequest,
} from '../../../extra-actions';
import {
  AddSequenceStepRequestPayload,
  AddSequenceStepVariantRequestPayload,
  AttachmentDeletePayload,
  SequenceStep,
  SequenceStepVariant,
  UpdateSequenceStepVariantDataRequestPayload,
} from '../../../types';
import { RootState } from '../../../../../store/root-reducer';
import updateProfileProgressRequest from '../../../../../shared/components/getting-started-onboarding/extra-actions';
import { UpdateProfileProgressPayload } from '../../../../../shared/types/user-setting';
import { getUserSettingsRequest } from '../../../../home/home-slice';
import {
  resetAddStepRequest,
  resetDeleteAttachmentRequest,
  resetUploadAttachmentRequest,
  sendCreateEmailWritingScoreForStepOne,
} from '../../../sequence-slice';
import { getFieldsRequest } from '../email-modal/test-email/extra-actions';

const mapStateToProps = (state: RootState) => ({
  addSequenceStepRequestStatus: state.sequence.addSequenceStepRequest.status,
  addSequenceStepRequestMessage: state.sequence.addSequenceStepRequest.message,
  addSequenceStepRequestError: state.sequence.addSequenceStepRequest.error,

  sequence: state.sequence.sequence,
  sequenceId: state.sequence.sequence?.id,
  totalSteps: state.sequence.sequence?.totalSteps || 0,
  stepNumber: (state.sequence.sequence?.totalSteps || 0) + 1,
  isFirstStep: (state.sequence.sequence?.totalSteps || 0) === 0,
  isFirstAutomatedEmailStep:
    state.sequence.sequence?.steps?.reduce(
      (a, b) =>
        a && b.executionType !== SequenceStepExecutionType.AutomatedEmail,
      true,
    ) ?? true,
  steps: state.sequence.sequence?.steps || [],
  profileProgress: state.home.profileProgress,
  updateProfileProgressRequestStatus:
    state.home.updateProfileProgressRequest.status,
  updateProfileProgressRequestMessage:
    state.home.updateProfileProgressRequest.message,
  updateProfileProgressRequestError:
    state.home.updateProfileProgressRequest.error,
  addSequenceStepVariantRequestStatus:
    state.sequence.addSequenceStepVariantRequest.status,
  updateSequenceStepVariantDataRequestStatus:
    state.sequence.updateSequenceStepVariantDataRequest.status,

  fields: state.emailModal.fields,
  taskAssigneeList: state.sequence.taskAssigneeList,
  userId: state.sequence?.sequence?.userId,
  updatedSteps: state.sequence.updatedSteps,
  subsequenceStepNumber: state.sequence?.subsequence?.totalSteps + 1,
  subsequenceSteps: state.sequence?.subsequence?.steps,
  subsequenceSettings: state.sequence?.subsequenceSettings,

  uploadAttachmentRequestStatus:
    state.sequence?.uploadAttachmentRequest?.status,
  uploadAttachmentRequestError: state.sequence?.uploadAttachmentRequest?.error,
  uploadedAttachment: state.sequence?.uploadedAttachment,
  deleteAttachmentRequestStatus:
    state.sequence?.deleteAttachmentRequest?.status,
  deleteAttachmentRequestError: state.sequence?.deleteAttachmentRequest?.error,
  deletedAttachmentId: state.sequence?.deletedAttachmentId,
  createTaskRequestStatus: state.tasks.createTaskRequest.status,
  getTaskAssigneeListRequestStatus:
    state.sequence.getTaskAssigneeListRequest.status,
});

const mapDispatchToProps = {
  sendGetSequenceRequest: (sequenceId: number) =>
    getSequenceRequest(sequenceId),
  sendAddSequenceStepRequest: (
    sequenceId: number,
    payload: AddSequenceStepRequestPayload,
  ) => addSequenceStepRequest({ sequenceId, ...payload }),
  sendAddSequenceStepVariantRequest: (
    sequenceId: number,
    stepId: number,
    payload: AddSequenceStepVariantRequestPayload,
  ) => addSequenceStepVariantRequest({ sequenceId, stepId, ...payload }),
  sendUpdateSequenceStepVariantDataRequest: (
    sequenceId: number,
    stepId: number,
    variantId: number,
    payload: UpdateSequenceStepVariantDataRequestPayload,
  ) =>
    updateSequenceStepVariantDataRequest({
      sequenceId,
      stepId,
      variantId,
      ...payload,
    }),
  sendGetUserSettingsRequest: () => getUserSettingsRequest(),
  updateProfileProgressRequest: (payload: UpdateProfileProgressPayload) =>
    updateProfileProgressRequest(payload),
  sendCreateEmailWritingScoreForStepOne: (val: boolean) =>
    sendCreateEmailWritingScoreForStepOne(val),
  sendGetFieldsRequest: () => getFieldsRequest(),
  sendGetTaskAssigneeListRequest: (includeAllAccountUsers?: boolean) =>
    getTaskAssigneeListRequest({ includeAllAccountUsers }),
  resetAddStepRequest: () => resetAddStepRequest(),
  sendGetSubsequenceRequest: (payload: number) =>
    getSubsequenceRequest(payload),

  // Add attachment and image upload related actions
  sendUploadAttachmentRequest: (payload) => uploadAttachmentRequest(payload),
  sendDeleteAttachmentRequest: (payload: AttachmentDeletePayload) =>
    deleteAttachmentRequest(payload),
  sendImageUploadRequest: (payload) => imageUploadRequest(payload),
  resetUploadAttachmentRequest: () => resetUploadAttachmentRequest(),
  resetDeleteAttachmentRequest: () => resetDeleteAttachmentRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AddStepModalProps = {
  show: boolean;
  stepType: StepType;
  initialStepType?: SequenceStepType;
  mode?: SequenceStepAction;
  actionStep?: SequenceStep;
  variantNumber?: number;
  variantStepNumber?: number;
  actionVariant?: SequenceStepVariant;
  defaultAbsoluteDay?: number;
  onClose: () => void;
  onStepTypeChange?: (type: StepType) => void;
  subsequenceId?: any;
  excludeStepTypes?: StepType[];
  isTaskModal?: boolean;
  sendCreateTaskRequest?: (payload: any) => void;
  prospectId?: number;
  className?: string;
  showCloseIcon?: boolean;
  CallLogId?: number;
  taskAssigneeFromDialer?: boolean;
};

export type IProps = ConnectedProps<typeof connector> & AddStepModalProps;
export default connector(CreateStepModal);
